/* eslint-disable import/prefer-default-export */
export const getRandomColor = lab => {
    if (lab.EXAME === 'CT') return '#90ee90'; // light green
    if (lab.EXAME === 'HDL') return '#add8e6'; // light blue
    if (lab.EXAME === 'Triglicerides') return '#ffffe0'; // light yellow
    if (lab.EXAME === 'LDL Calculado') return '#dda0dd'; // plum (soft magenta)
    if (lab.EXAME === 'Hb glicada') return '#f08080'; // light coral (soft red)
    if (lab.EXAME === 'Ácido úrico') return '#b0e0e6'; // powder blue
    if (lab.EXAME === 'Uréia') return '#e0ffff'; // light cyan
    if (lab.EXAME === 'Glicemia') return '#fffaf0'; // floral white
    if (lab.EXAME === 'K') return '#f8f8ff'; // ghost white
    if (lab.EXAME === 'Na') return '#bc8f8f'; // rosy brown (softer brown)
    if (lab.EXAME === 'Creatinina') return '#98fb98'; // pale green
    if (lab.EXAME === 'TGP') return '#bda0ff'; // soft blue-violet
    if (lab.EXAME === 'TGO') return '#f5deb3'; // wheat (soft burlywood)
    if (lab.EXAME === 'TSH') return '#e0fff0'; // very light aquamarine
    if (lab.EXAME === 'T4') return '#f4a460'; // sandy brown
    if (lab.EXAME === 'PSA') return '#e6f0fa'; // very light blue
    if (lab.EXAME === 'Urina I') return '#cba0ff'; // soft dark violet
    if (lab.EXAME === 'Vitamina D') return '#ffb6c1'; // light pink
    if (lab.EXAME === 'HT') return '#b0e0ff'; // light sky blue
    if (lab.EXAME === 'Hb') return '#eeeeee'; // light gray
    if (lab.EXAME === 'Hemograma') return '#fffacd'; // lemon chiffon
    if (lab.EXAME === 'Magnésio') return '#f0fff0'; // honeydew
    if (lab.EXAME === 'Ferritina') return '#fafad2'; // light goldenrod yellow
};